import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/api/auth.service';

export const twoFactorGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const user = authService.currentUser();
    const router = inject(Router);

    //Si el usuario tiene 2FA habilitado y no está autenticado
    if (user?.two_factor_enabled && !authService.isAuthenticated()) {
        router.navigate(['/auth/multifactor']).then(r => {});
        return false;
    }

    return true;
};
